// Favorite quotes — saved privately on-device via localStorage.
// Shape: [{ text, author?, savedAt }] newest first.
// by David Hunt

const STORAGE_KEY = "stillwater.favoriteQuotes";

export const getFavorites = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch (_) {
    return [];
  }
};

const save = (list) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (_) {
    /* silent */
  }
};

export const isFavorite = (text) =>
  getFavorites().some((q) => q.text === text);

// Returns true if the quote is now saved, false if it was removed.
export const toggleFavorite = (quote) => {
  const list = getFavorites();
  if (list.some((q) => q.text === quote.text)) {
    save(list.filter((q) => q.text !== quote.text));
    return false;
  }
  save([
    { text: quote.text, author: quote.author, savedAt: new Date().toISOString() },
    ...list,
  ]);
  return true;
};

export const removeFavorite = (text) => {
  save(getFavorites().filter((q) => q.text !== text));
};

// A random kept line, avoiding the one currently on screen.
export const pickFavorite = (excludeText) => {
  const pool = getFavorites().filter((q) => q.text !== excludeText);
  if (pool.length === 0) return null;
  return pool[Math.floor(Math.random() * pool.length)];
};
